
const KorisnikOrdinacija = function(DS) {
    return DS.defineResource({
        name: 'KorisnikOrdinacija',
        endpoint: '/korisnikOrdinacija'
    });
};

KorisnikOrdinacija.$inject = ['DS'];


export {KorisnikOrdinacija};



// WEBPACK FOOTER //
// ./app/models/korisnikOrdinacija.js